export class AuditableEntity {
  logedUser: string;
  createdBy: string;
  updatedBy: string;

  updatedDate: string;
  createdDate: string;
}
